export default "__VITE_ASSET__8a7i3CY1__"